<div class="buscar-container safe-area-inset-top">

  <!-- Header -->
  <div class="buscar-header">
    <button class="back-btn" (click)="goBack()">
      <span>&larr;</span>
    </button>
    <h1 class="buscar-title">Buscar negocios</h1>
  </div>

  <!-- Search bar + filter toggle -->
  <div class="search-section">
    <div class="search-row">
      <input
        type="text"
        class="search-input"
        placeholder="Buscar por nombre..."
        [(ngModel)]="searchQuery"
        (input)="onSearchInput()"
      />
      <button class="search-btn" (click)="doSearch()">
        <span>Buscar</span>
      </button>
      <button class="filter-toggle-btn" (click)="toggleFilters()" [class.has-filters]="activeFilterCount > 0">
        <span class="filter-icon-btn">&#9776;</span>
        <span class="filter-count" *ngIf="activeFilterCount > 0">{{ activeFilterCount }}</span>
      </button>
    </div>

    <!-- Filter chips (collapsible) -->
    <div class="filter-chips" *ngIf="showFilters">
      <button
        *ngFor="let f of serviceFilters"
        class="filter-chip"
        [class.active]="f.active"
        (click)="toggleFilter(f)"
      >
        <span class="chip-icon">{{ f.icon }}</span>
        <span class="chip-text">{{ f.label }}</span>
      </button>
    </div>
  </div>

  <!-- Results -->
  <div class="results-section">

    <!-- Loading -->
    <div class="loading-state" *ngIf="loading">
      <div class="spinner"></div>
      <span>Buscando...</span>
    </div>

    <!-- Empty state -->
    <div class="empty-state" *ngIf="!loading && searched && results.length === 0">
      <span class="empty-icon">🤷</span>
      <p>No se encontraron negocios{{ searchQuery.trim() ? ' para "' + searchQuery + '"' : '' }}</p>
      <p class="empty-hint">Prueba con otro nombre o quita los filtros</p>
    </div>

    <!-- Results list -->
    <div class="business-list" *ngIf="!loading && results.length > 0">
      <a *ngFor="let biz of results" class="business-card" [routerLink]="['/business', biz.id]">
        <div class="biz-logo" *ngIf="biz.logo_url">
          <img [src]="resolveImg(biz.logo_url)" [alt]="biz.name" />
        </div>
        <div class="biz-logo biz-logo-placeholder" *ngIf="!biz.logo_url">
          <span>{{ getBusinessTypeIcon(biz.business_type) }}</span>
        </div>
        <div class="biz-info">
          <div class="biz-name-row">
            <span class="biz-name">{{ biz.name }}</span>
            <span class="biz-type-badge" *ngIf="biz.business_type_name">{{ biz.business_type_name }}</span>
          </div>
          <span class="biz-address" *ngIf="biz.address || biz.city">{{ biz.address || biz.city }}</span>
          <div class="biz-caps">
            <span class="cap-badge" *ngFor="let cap of getCapabilities(biz)">{{ cap }}</span>
          </div>
        </div>

        <!-- Action labels -->
        <div class="biz-actions">
          <span class="action-label action-pedir" *ngIf="canOrder(biz)">Pedir</span>
          <span class="action-label action-reservar" *ngIf="canReserve(biz)">Reservar</span>
        </div>
      </a>
    </div>

  </div>

</div>
